import useEffectOnce from './useEffectOnce';
var useMount = function (fn) {
    useEffectOnce(function () {
        fn();
    });
};
export default useMount;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-use/esm/useMount.js
// module id = LgrO
// module chunks = 0